@if(labelLoaded){
  @if(isLoggedIn){
    <!-- <p style="margin-left: 200px; margin-top: -60px; position: relative; z-index: 100000">Hello {{IDLE_TIMEOUT}} & {{WARNING_TIME}} & {{lastActivityTime}} & {{idleCheckInterval}}</p> -->
    <app-header></app-header>
    <div>
      <app-navbar></app-navbar>
    </div>
  }
  @if(sessionExpWarning){
    <app-re-login (destroy)="toggleReAuth($event)"></app-re-login>
  }
  <router-outlet></router-outlet>
}

<div id="loginVital" class="d-none">{{metrics | json}}</div>


